import React from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import './DuzenlemeKurulu.css';

function DuzenlemeKurulu() {
  // Murat Durgun ve Ülkü Tutar yardımcılar kısmına çıktığı için listeden çıkarıldı
  const kurulUyeleri = [
    { ad: "Prof. Dr. A. Asuman Akdoğan", kurum: "Erciyes Üniversitesi" },
    { ad: "Prof. Dr. Esin Can", kurum: "Yıldız Teknik Üniversitesi" },
    { ad: "Prof. Dr. Mehmet Barca", kurum: "Ankara Sosyal Bilimler Üniversitesi" },
    { ad: "Prof. Dr. Şebnem Arıkboğa", kurum: "İstanbul Üniversitesi" },
    { ad: "Doç. Dr. Alptekin Develi", kurum: "Gaziosmanpaşa Üniversitesi" },
    { ad: "Doç. Dr. Emrah Koparan", kurum: "Amasya Üniversitesi" },
    { ad: "Doç. Dr. Cihat Erbil", kurum: "Hacı Bayram Veli Üniversitesi" },
    { ad: "Doç. Dr. Zümral Gültekin", kurum: "Ondokuz Mayıs Üniversitesi" },
    { ad: "Dr. Öğretim Üyesi Metin Günay", kurum: "Sivas Cumhuriyet Üniversitesi" },
    { ad: "Doç. Dr. M. Said Döven", kurum: "Gaziosmanpaşa Üniversitesi" },
    { ad: "Dr. Öğretim Üyesi Pelin Erden Çevik", kurum: "Hacı Bayram Veli Üniversitesi" },
    { ad: "Dr. Abdullah Karaçınar", kurum: "Türk Telekom" }
  ];

  return (
    <div className="duzenleme-page">
      <Navbar />
      
      <header className="page-hero">
        <div className="container">
          <h2>Düzenleme Kurulu</h2>
          <p>34. Ulusal Yönetim ve Organizasyon Kongresi</p>
        </div>
      </header>

      <main className="content-container">
        {/* BAŞKAN - ÜST BÖLÜM (TEK) */}
        <div className="leadership-main">
          <div className="leader-card gold">
            <span className="task">Kongre Dönem ve Düzenleme Kurulu Başkanı</span>
            <h3>Prof. Dr. Berrin FİLİZÖZ</h3>
            <span className="uni">Sivas Cumhuriyet Üniversitesi</span>
          </div>
        </div>

        {/* YARDIMCILAR - ORTA BÖLÜM (2 KİŞİ) */}
        <div className="leadership-grid assistants">
          <div className="leader-card">
            <span className="task">Kongre Düzenleme Kurulu Başkan Yardımcısı</span>
            <h3>Dr. Öğretim Üyesi Murat DURGUN</h3>
            <span className="uni">Sivas Cumhuriyet Üniversitesi</span>
          </div>

          <div className="leader-card">
            <span className="task">Kongre Düzenleme Kurulu Başkan Yardımcısı</span>
            <h3>Dr. Öğretim Görevlisi Ülkü TUTAR</h3>
            <span className="uni">Sivas Cumhuriyet Üniversitesi</span>
          </div>

          <div className="leadership-main social-media-manager">
          <div className="leader-card blue">
            <span className="task">Sosyal Medya Yöneticisi</span>
            <h3>Ersin İRKİLATA</h3>
            <span className="uni">Sivas Cumhuriyet Üniversitesi</span>
          </div>
        </div>
        </div>

        {/* ÜYE LİSTESİ */}
        <div className="members-section">
          <h3>Kurul Üyeleri</h3>
          <div className="members-grid">
            {kurulUyeleri.map((uye, index) => (
              <div key={index} className="member-item">
                <div className="member-info">
                  <span className="m-name">{uye.ad}</span>
                  <span className="m-uni">{uye.kurum}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default DuzenlemeKurulu;